import React from 'react';
import * as css from './ArrivalConfirmationDetails.css';
import EyeHideSection from '../../components/eyeHideSection/EyeHideSection';
import {useSelector} from 'react-redux';
import Location from '../../../assets/icons/Location ';
import Time from '../../../assets/icons/Time';
import Title from '../../../assets/icons/Title';
import {getDateFormat} from '../../../library/dates';

function ArrivalConfirmationDetails() {
    const {title, location, timeZone, timeStart} = useSelector(({event}) => ({
        title: event.title,
        location: event.location,
        timeZone: event.timeZone,
        timeStart: event.timeStart
    }));
    
    const details = [
        {icon: <Title />, value: title, sectionName: 'title'},
        {icon: <Location />, value: location, sectionName: 'location'},
        {icon: <Time />, value: timeStart ? getDateFormat(timeStart, 'YYYY-MM-DD HH:mm', timeZone) : null, sectionName: 'timeStart'},
    ].filter(detail => detail.value);

    return (   
        <css.wrapper data-cy="ArrivalConfirmationDetails">
            {details.map(({icon, value, sectionName}, index) => (
                <EyeHideSection key={index} sectionName={sectionName}>
                    <css.detail>
                        {icon}
                        <css.text>{value}</css.text>
                    </css.detail>
                </EyeHideSection>
            ))}
        </css.wrapper>
    );
}

export default ArrivalConfirmationDetails ;